import Alpine from 'alpinejs';
import MembersSlider from "./blocks/members-slider";
import FileUpload from "./components/FileUpload";
import SmoothScrollAnchors from "./components/SmoothScrollAnchors";
import MenuAnchors from "./parts/MenuAnchors";
import Select from "./parts/Select";

MembersSlider().init();
SmoothScrollAnchors().init();
MenuAnchors().init();
Select().init();

Alpine.data('FileUpload', FileUpload);

window.Alpine = Alpine;

Alpine.start();